export enum ProviderName {
  stripe = 'Stripe',
  offline = 'Offline',
  paysafe = 'Paysafe',
}
